// @ts-nocheck

import styled, { createGlobalStyle, css } from 'styled-components';

import { Target } from '../client';
import { NAVBAR_BASE_HEIGHT } from '../constants/ui/navbar';
import { TABBAR_BASE_HEIGHT } from '../constants/ui/tabbar';
import { isLibrary } from '../lib/useragent';

import CollapseStyles from './collapse';
import { DesktopStyle } from './desktop';
import LibStyle from './lib';
import { MobileStyle } from './mobile';
import { MobileNormalize } from './normalize';

export const RootGlobalStyle = createGlobalStyle`
  ${Target.__MOBILE__ ? MobileNormalize + MobileStyle : DesktopStyle}
  ${isLibrary ? LibStyle : undefined}
  ${CollapseStyles}
  #app, #winabet-portal-root, #winabet-app-root, #storybook {
    font-family: 'BettingArchivoNarrow', sans-serif;
    input, button {
      font-family: 'BettingArchivoNarrow', sans-serif;
    }
  }

  body {
    --navbar-height: ${NAVBAR_BASE_HEIGHT}em;
    --navbar-height: calc(${NAVBAR_BASE_HEIGHT}em + constant(safe-area-inset-top));
    --navbar-height: calc(${NAVBAR_BASE_HEIGHT}em + env(safe-area-inset-top));

    --tabbar-height: ${TABBAR_BASE_HEIGHT}em;
    --tabbar-height: calc(${TABBAR_BASE_HEIGHT}em + constant(safe-area-inset-bottom));
    --tabbar-height: calc(${TABBAR_BASE_HEIGHT}em + env(safe-area-inset-bottom));
  }
`;

export const AnimationsGlobalStyle = createGlobalStyle`
  @keyframes glow-with-drop-shadow {
    0% {
      filter: drop-shadow(0px 0px 0.3em transparent);
    }
    50% {
      filter: drop-shadow(0px 0px 0.3em white);
    }
    100% {
      filter: drop-shadow(0px 0px 0.3em transparent);
    }
  }
`;

export const BoxSizingDefaultClassName = 'box-sizing-default';
export const ResetStyle = createGlobalStyle`
  #app, #winabet-portal-root, #winabet-app-root, #storybook {
    *:not(.${BoxSizingDefaultClassName}),
    *:not(.${BoxSizingDefaultClassName}):before,
    *:not(.${BoxSizingDefaultClassName}):after {
      box-sizing: border-box;
    }
  }
`;

export const AppInnerStyle = styled.div`
  ${Target.__MOBILE__
    ? css`
        transform: translateZ(0);
      `
    : css`
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;

        ${({ theme }) => {
          return css`
            @media screen and (min-width: ${theme.breakpoints.lg + 1}px) {
              font-size: 1em;
            }
          `;
        }}
      `}
`;

export const SportRadarGlobalStyle = createGlobalStyle`
  .sr-bb {
    font-family: 'Roboto', 'Noto', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
    background: #ffffff;
  }

  .sr-bb .sr-bb {
    background: none;
  }

  .sr-bb .srt-base-1 {
    background-color: transparent;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-win {
    background-color: transparent;
    color: red;
    border-color: red;
  }

  .sr-bb .srt-base-1-draw {
    background-color: transparent;
    color: #c2c2c2;
    border-color: #c2c2c2;
  }

  .sr-bb .srt-base-1-lose {
    background-color: transparent;
    color: #ff8787;
    border-color: #ff8787;
  }

  .sr-bb .srt-base-1-is-active {
    background-color: rgba(255, 0, 0, 0.12);
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-is-active-2 {
    background-color: #e6e6e6;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-is-hoverable:hover {
    background-color: rgba(255, 0, 0, 0.12);
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-primary {
    background-color: transparent;
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-home-1 {
    background-color: transparent;
    color: #3f3f41;
    border-color: #3f3f41;
  }

  .sr-bb .srt-base-1-away-1 {
    background-color: transparent;
    color: #9c9c9c;
    border-color: #9c9c9c;
  }

  .sr-bb .srt-base-1-home-2 {
    background-color: transparent;
    color: #3f3f41;
    border-color: #940000;
  }

  .sr-bb .srt-base-1-away-2 {
    background-color: transparent;
    color: #9c9c9c;
    border-color: #940000;
  }

  .sr-bb .srt-base-1-home-3 {
    background-color: transparent;
    color: #3f3f41;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-away-3 {
    background-color: transparent;
    color: #9c9c9c;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-home-4 {
    background-color: transparent;
    color: #79797a;
    border-color: #79797a;
  }

  .sr-bb .srt-base-1-away-4 {
    background-color: transparent;
    color: #bababa;
    border-color: #bababa;
  }

  .sr-bb .srt-base-1-home-5 {
    background-color: transparent;
    color: #29292a;
    border-color: #29292a;
  }

  .sr-bb .srt-base-1-away-5 {
    background-color: transparent;
    color: #656565;
    border-color: #656565;
  }

  .sr-bb .srt-base-1-background {
    background-color: white;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-2 {
    background-color: white;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-2-is-active {
    background-color: #ffe0e0;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-2-is-hoverable:hover {
    background-color: #ffe0e0;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-3 {
    background-color: #ffe0e0;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-3-is-active {
    background-color: #ffd4d4;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-3-is-hoverable:hover {
    background-color: #ffd4d4;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-3-background {
    background-color: white;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-4 {
    background-color: #fff2f2;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-5-is-active {
    background-color: #ffbdbd;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-5-is-hoverable:hover {
    background-color: #ffbdbd;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-6 {
    background-color: transparent;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.3);
  }

  .sr-bb .srt-primary-1 {
    background-color: #ff0000;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-1-is-active {
    background-color: #ff1a1a;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-1-is-hoverable:hover {
    background-color: #ff1a1a;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-1-is-disabled {
    background-color: #ff3333;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-2 {
    background-color: #b30000;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-3 {
    background-color: #ff1a1a;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-4 {
    background-color: #ff6666;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-5 {
    background-color: #ff6666;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-5-is-hoverable:hover {
    background-color: #ff0000;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-6 {
    background-color: #940000;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-7 {
    background-color: #ff0000;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-8 {
    background-color: #ff0000;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-8-is-active-1 {
    background-color: #ff1a1a;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-8-is-active-2 {
    background-color: #ff1a1a;
    color: #ffffff;
    border-color: #ffffff;
  }

  .sr-bb .srt-primary-9 {
    background-color: #ffb3b3;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-primary-10 {
    background-color: #ff3333;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-11 {
    background-color: #ff1a1a;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-primary-12 {
    background-color: #ff0000;
    color: #ffffff;
    border-color: #ffffff;
  }

  .sr-bb .srt-primary-13 {
    background-color: #fff2f2;
    color: #ffffff;
    border-color: rgba(255, 0, 0, 0.3);
  }

  .sr-bb .srt-base-1-primary-1 {
    background-color: transparent;
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-primary-2 {
    background-color: transparent;
    color: #b30000;
    border-color: #b30000;
  }

  .sr-bb .srt-base-1-primary-3 {
    background-color: transparent;
    color: #ff1a1a;
    border-color: #ff1a1a;
  }

  .sr-bb .srt-base-1-primary-4 {
    background-color: transparent;
    color: #ff6666;
    border-color: #ff6666;
  }

  .sr-bb .srt-base-1-primary-5 {
    background-color: transparent;
    color: #ff6666;
    border-color: #ff6666;
  }

  .sr-bb .srt-base-1-primary-6 {
    background-color: transparent;
    color: #940000;
    border-color: #940000;
  }

  .sr-bb .srt-base-1-primary-7 {
    background-color: transparent;
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-primary-8 {
    background-color: transparent;
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-primary-9 {
    background-color: transparent;
    color: #ffb3b3;
    border-color: #ffb3b3;
  }

  .sr-bb .srt-base-1-primary-10 {
    background-color: transparent;
    color: #ff3333;
    border-color: #ff3333;
  }

  .sr-bb .srt-base-1-primary-11 {
    background-color: transparent;
    color: #ff1a1a;
    border-color: #ff1a1a;
  }

  .sr-bb .srt-base-1-primary-13 {
    background-color: #ffffff;
    color: #fff2f2;
    border-color: rgba(255, 0, 0, 0.3);
  }

  .sr-bb .srt-base-1-neutral-1 {
    background-color: transparent;
    color: #dedede;
    border-color: #dedede;
  }

  .sr-bb .srt-base-1-neutral-2 {
    background-color: transparent;
    color: #1a1a1a;
    border-color: #1a1a1a;
  }

  .sr-bb .srt-base-1-neutral-3 {
    background-color: transparent;
    color: rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-neutral-4 {
    background-color: transparent;
    color: #595959;
    border-color: #595959;
  }

  .sr-bb .srt-base-1-neutral-5 {
    background-color: transparent;
    color: #404040;
    border-color: #404040;
  }

  .sr-bb .srt-base-1-neutral-6 {
    background-color: transparent;
    color: #c2c2c2;
    border-color: #c2c2c2;
  }

  .sr-bb .srt-base-1-neutral-7 {
    background-color: transparent;
    color: #595959;
    border-color: #595959;
  }

  .sr-bb .srt-base-1-neutral-8 {
    background-color: transparent;
    color: #dedede;
    border-color: #dedede;
  }

  .sr-bb .srt-base-1-neutral-9 {
    background-color: transparent;
    color: #f0f0f0;
    border-color: #f0f0f0;
  }

  .sr-bb .srt-base-1-neutral-10 {
    background-color: transparent;
    color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .sr-bb .srt-base-1-neutral-11 {
    background-color: transparent;
    color: #999999;
    border-color: #999999;
  }

  .sr-bb .srt-base-1-neutral-12 {
    background-color: transparent;
    color: #4d4d4d;
    border-color: #4d4d4d;
  }

  .sr-bb .srt-base-1-neutral-13 {
    background-color: transparent;
    color: #e6e6e6;
    border-color: #e6e6e6;
  }

  .sr-bb .srt-base-1-is-active-primary {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-is-active-home-1 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #3f3f41;
    border-color: #3f3f41;
  }

  .sr-bb .srt-base-1-is-active-away-1 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #9c9c9c;
    border-color: #9c9c9c;
  }

  .sr-bb .srt-base-1-is-active-home-2 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #3f3f41;
    border-color: #940000;
  }

  .sr-bb .srt-base-1-is-active-away-2 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #9c9c9c;
    border-color: #940000;
  }

  .sr-bb .srt-base-1-is-active-home-3 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #3f3f41;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-is-active-away-3 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #9c9c9c;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-is-active-home-4 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #79797a;
    border-color: #79797a;
  }

  .sr-bb .srt-base-1-is-active-away-4 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #bababa;
    border-color: #bababa;
  }

  .sr-bb .srt-base-1-is-active-home-5 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #29292a;
    border-color: #29292a;
  }

  .sr-bb .srt-base-1-is-active-away-5 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #656565;
    border-color: #656565;
  }

  .sr-bb .srt-base-1-is-active-primary-1 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-is-active-primary-2 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #b30000;
    border-color: #b30000;
  }

  .sr-bb .srt-base-1-is-active-primary-3 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff1a1a;
    border-color: #ff1a1a;
  }

  .sr-bb .srt-base-1-is-active-primary-4 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff6666;
    border-color: #ff6666;
  }

  .sr-bb .srt-base-1-is-active-primary-5 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff6666;
    border-color: #ff6666;
  }

  .sr-bb .srt-base-1-is-active-primary-6 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #940000;
    border-color: #940000;
  }

  .sr-bb .srt-base-1-is-active-primary-7 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-is-active-primary-8 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff0000;
    border-color: #ff0000;
  }

  .sr-bb .srt-base-1-is-active-primary-9 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ffb3b3;
    border-color: #ffb3b3;
  }

  .sr-bb .srt-base-1-is-active-primary-10 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff3333;
    border-color: #ff3333;
  }

  .sr-bb .srt-base-1-is-active-primary-11 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #ff1a1a;
    border-color: #ff1a1a;
  }

  .sr-bb .srt-base-1-is-active-neutral-1 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #dedede;
    border-color: #dedede;
  }

  .sr-bb .srt-base-1-is-active-neutral-2 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #1a1a1a;
    border-color: #1a1a1a;
  }

  .sr-bb .srt-base-1-is-active-neutral-3 {
    background-color: rgba(255, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-base-1-is-active-neutral-4 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #595959;
    border-color: #595959;
  }

  .sr-bb .srt-base-1-is-active-neutral-5 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #404040;
    border-color: #404040;
  }

  .sr-bb .srt-base-1-is-active-neutral-6 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #c2c2c2;
    border-color: #c2c2c2;
  }

  .sr-bb .srt-base-1-is-active-neutral-7 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #595959;
    border-color: #595959;
  }

  .sr-bb .srt-base-1-is-active-neutral-8 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #dedede;
    border-color: #dedede;
  }

  .sr-bb .srt-base-1-is-active-neutral-9 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #f0f0f0;
    border-color: #f0f0f0;
  }

  .sr-bb .srt-base-1-is-active-neutral-10 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #e0e0e0;
    border-color: #e0e0e0;
  }

  .sr-bb .srt-base-1-is-active-neutral-11 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #999999;
    border-color: #999999;
  }

  .sr-bb .srt-base-1-is-active-neutral-12 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #4d4d4d;
    border-color: #4d4d4d;
  }

  .sr-bb .srt-base-1-is-active-neutral-13 {
    background-color: rgba(255, 0, 0, 0.12);
    color: #e6e6e6;
    border-color: #e6e6e6;
  }

  .sr-bb .srt-home-1 {
    background-color: #3f3f41;
    color: #ffffff;
    border-color: #3f3f41;
  }

  .sr-bb .srt-away-1 {
    background-color: #9c9c9c;
    color: #000000;
    border-color: #9c9c9c;
  }

  .sr-bb .srt-home-2 {
    background-color: #3f3f41;
    color: #ffffff;
    border-color: #940000;
  }

  .sr-bb .srt-away-2 {
    background-color: #9c9c9c;
    color: #000000;
    border-color: #940000;
  }

  .sr-bb .srt-home-3 {
    background-color: #3f3f41;
    color: #ffffff;
    border-color: #ffffff;
  }

  .sr-bb .srt-away-3 {
    background-color: #9c9c9c;
    color: #000000;
    border-color: #ffffff;
  }

  .sr-bb .srt-home-4 {
    background-color: #79797a;
    color: #ffffff;
    border-color: #79797a;
  }

  .sr-bb .srt-away-4 {
    background-color: #bababa;
    color: #000000;
    border-color: #bababa;
  }

  .sr-bb .srt-home-5 {
    background-color: #29292a;
    color: #ffffff;
    border-color: #29292a;
  }

  .sr-bb .srt-away-5 {
    background-color: #656565;
    color: #000000;
    border-color: #656565;
  }

  .sr-bb .srt-neutral-1 {
    background-color: #dedede;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-2 {
    background-color: #1a1a1a;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-neutral-3 {
    background-color: rgba(0, 0, 0, 0.12);
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-4 {
    background-color: #595959;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-neutral-5 {
    background-color: #404040;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-neutral-6 {
    background-color: #c2c2c2;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-7 {
    background-color: #595959;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-neutral-8 {
    background-color: #dedede;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-9 {
    background-color: #f0f0f0;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-10 {
    background-color: #e0e0e0;
    color: rgba(0, 0, 0, 0.82);
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-11 {
    background-color: #999999;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-neutral-12 {
    background-color: #4d4d4d;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-neutral-13 {
    background-color: #e6e6e6;
    color: #000000;
    border-color: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-win {
    background-color: red;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-draw {
    background-color: #c2c2c2;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-lose {
    background-color: #ff8787;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-text-secondary {
    opacity: 0.7;
  }

  .sr-bb .srt-text-disabled {
    opacity: 0.35;
  }

  .sr-bb .srt-text-tertiary {
    opacity: 0.54;
  }

  .sr-bb .srt-primary-1 .srt-text-secondary,
  .sr-bb .srt-primary-1.srt-text-secondary,
  .sr-bb .srt-primary-1-is-active .srt-text-secondary,
  .sr-bb .srt-primary-1-is-active.srt-text-secondary,
  .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-secondary,
  .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-secondary,
  .sr-bb .srt-primary-1-is-disabled .srt-text-secondary,
  .sr-bb .srt-primary-1-is-disabled.srt-text-secondary,
  .sr-bb .srt-primary-2 .srt-text-secondary,
  .sr-bb .srt-primary-2.srt-text-secondary,
  .sr-bb .srt-primary-3 .srt-text-secondary,
  .sr-bb .srt-primary-3.srt-text-secondary,
  .sr-bb .srt-primary-4 .srt-text-secondary,
  .sr-bb .srt-primary-4.srt-text-secondary,
  .sr-bb .srt-primary-5 .srt-text-secondary,
  .sr-bb .srt-primary-5.srt-text-secondary,
  .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-secondary,
  .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-secondary,
  .sr-bb .srt-primary-6 .srt-text-secondary,
  .sr-bb .srt-primary-6.srt-text-secondary,
  .sr-bb .srt-primary-7 .srt-text-secondary,
  .sr-bb .srt-primary-7.srt-text-secondary,
  .sr-bb .srt-primary-8 .srt-text-secondary,
  .sr-bb .srt-primary-8.srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-1 .srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-1.srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-2 .srt-text-secondary,
  .sr-bb .srt-primary-8-is-active-2.srt-text-secondary,
  .sr-bb .srt-primary-9 .srt-text-secondary,
  .sr-bb .srt-primary-9.srt-text-secondary,
  .sr-bb .srt-primary-10 .srt-text-secondary,
  .sr-bb .srt-primary-10.srt-text-secondary,
  .sr-bb .srt-primary-11 .srt-text-secondary,
  .sr-bb .srt-primary-11.srt-text-secondary,
  .sr-bb .srt-primary-12 .srt-text-secondary,
  .sr-bb .srt-primary-12.srt-text-secondary,
  .sr-bb .srt-primary-13 .srt-text-secondary,
  .sr-bb .srt-primary-13.srt-text-secondary {
    opacity: 0.8;
  }

  .sr-bb .srt-primary-1 .srt-text-disabled,
  .sr-bb .srt-primary-1.srt-text-disabled,
  .sr-bb .srt-primary-1-is-active .srt-text-disabled,
  .sr-bb .srt-primary-1-is-active.srt-text-disabled,
  .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-disabled,
  .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-disabled,
  .sr-bb .srt-primary-1-is-disabled .srt-text-disabled,
  .sr-bb .srt-primary-1-is-disabled.srt-text-disabled,
  .sr-bb .srt-primary-2 .srt-text-disabled,
  .sr-bb .srt-primary-2.srt-text-disabled,
  .sr-bb .srt-primary-3 .srt-text-disabled,
  .sr-bb .srt-primary-3.srt-text-disabled,
  .sr-bb .srt-primary-4 .srt-text-disabled,
  .sr-bb .srt-primary-4.srt-text-disabled,
  .sr-bb .srt-primary-5 .srt-text-disabled,
  .sr-bb .srt-primary-5.srt-text-disabled,
  .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-disabled,
  .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-disabled,
  .sr-bb .srt-primary-6 .srt-text-disabled,
  .sr-bb .srt-primary-6.srt-text-disabled,
  .sr-bb .srt-primary-7 .srt-text-disabled,
  .sr-bb .srt-primary-7.srt-text-disabled,
  .sr-bb .srt-primary-8 .srt-text-disabled,
  .sr-bb .srt-primary-8.srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-1 .srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-1.srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-2 .srt-text-disabled,
  .sr-bb .srt-primary-8-is-active-2.srt-text-disabled,
  .sr-bb .srt-primary-9 .srt-text-disabled,
  .sr-bb .srt-primary-9.srt-text-disabled,
  .sr-bb .srt-primary-10 .srt-text-disabled,
  .sr-bb .srt-primary-10.srt-text-disabled,
  .sr-bb .srt-primary-11 .srt-text-disabled,
  .sr-bb .srt-primary-11.srt-text-disabled,
  .sr-bb .srt-primary-12 .srt-text-disabled,
  .sr-bb .srt-primary-12.srt-text-disabled,
  .sr-bb .srt-primary-13 .srt-text-disabled,
  .sr-bb .srt-primary-13.srt-text-disabled {
    opacity: 0.6;
  }

  .sr-bb .srt-primary-1 .srt-text-tertiary,
  .sr-bb .srt-primary-1.srt-text-tertiary,
  .sr-bb .srt-primary-1-is-active .srt-text-tertiary,
  .sr-bb .srt-primary-1-is-active.srt-text-tertiary,
  .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-tertiary,
  .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-tertiary,
  .sr-bb .srt-primary-1-is-disabled .srt-text-tertiary,
  .sr-bb .srt-primary-1-is-disabled.srt-text-tertiary,
  .sr-bb .srt-primary-2 .srt-text-tertiary,
  .sr-bb .srt-primary-2.srt-text-tertiary,
  .sr-bb .srt-primary-3 .srt-text-tertiary,
  .sr-bb .srt-primary-3.srt-text-tertiary,
  .sr-bb .srt-primary-4 .srt-text-tertiary,
  .sr-bb .srt-primary-4.srt-text-tertiary,
  .sr-bb .srt-primary-5 .srt-text-tertiary,
  .sr-bb .srt-primary-5.srt-text-tertiary,
  .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-tertiary,
  .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-tertiary,
  .sr-bb .srt-primary-6 .srt-text-tertiary,
  .sr-bb .srt-primary-6.srt-text-tertiary,
  .sr-bb .srt-primary-7 .srt-text-tertiary,
  .sr-bb .srt-primary-7.srt-text-tertiary,
  .sr-bb .srt-primary-8 .srt-text-tertiary,
  .sr-bb .srt-primary-8.srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-1 .srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-1.srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-2 .srt-text-tertiary,
  .sr-bb .srt-primary-8-is-active-2.srt-text-tertiary,
  .sr-bb .srt-primary-9 .srt-text-tertiary,
  .sr-bb .srt-primary-9.srt-text-tertiary,
  .sr-bb .srt-primary-10 .srt-text-tertiary,
  .sr-bb .srt-primary-10.srt-text-tertiary,
  .sr-bb .srt-primary-11 .srt-text-tertiary,
  .sr-bb .srt-primary-11.srt-text-tertiary,
  .sr-bb .srt-primary-12 .srt-text-tertiary,
  .sr-bb .srt-primary-12.srt-text-tertiary,
  .sr-bb .srt-primary-13 .srt-text-tertiary,
  .sr-bb .srt-primary-13.srt-text-tertiary {
    opacity: 0.7;
  }

  .sr-bb .srt-icon {
    opacity: 0.33;
  }

  .sr-bb .srt-icon-secondary {
    opacity: 0.7;
  }

  .sr-bb .srt-elevation-1 {
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  }

  .sr-bb .srt-elevation-2 {
    box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.23), 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-elevation-3 {
    box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.26), 0px 10px 20px 0px rgba(0, 0, 0, 0.19);
  }

  .sr-bb .srt-elevation-center-2 {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.23), 0 1px 5px rgba(0, 0, 0, 0.16);
  }

  .sr-bb .srt-inset-top-1 {
    box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-bottom-1 {
    box-shadow: inset 0 -1px 2px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-top-2 {
    box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-bottom-2 {
    box-shadow: inset 0 -3px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-top-3 {
    box-shadow: inset 0 6px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-inset-bottom-3 {
    box-shadow: inset 0 -6px 6px 0 rgba(0, 0, 0, 0.23);
  }

  .sr-bb .srt-fill-blue-card {
    fill: #2579ad;
  }

  .sr-bb .srt-stroke-blue-card {
    stroke: #2579ad;
  }

  .sr-bb .srt-fill-soccer-yellow-card {
    fill: #ffbf00;
  }

  .sr-bb .srt-stroke-soccer-yellow-card {
    stroke: #ffbf00;
  }

  .sr-bb .srt-fill-soccer-red-card {
    fill: #e43b3b;
  }

  .sr-bb .srt-stroke-soccer-red-card {
    stroke: #e43b3b;
  }

  .sr-bb .srt-stroke-soccer-substitution-in {
    stroke: #4fbe30;
    fill: transparent;
  }

  .sr-bb .srt-fill-soccer-substitution-in {
    fill: #4fbe30;
  }

  .sr-bb .srt-stroke-soccer-substitution-out {
    stroke: #e43b3b;
    fill: transparent;
  }

  .sr-bb .srt-fill-soccer-substitution-out {
    fill: #e43b3b;
  }

  .sr-bb .srt-stroke-soccer-own-goal {
    stroke: #e43b3b;
    fill: transparent;
  }

  .sr-bb .srt-fill-soccer-own-goal {
    fill: #e43b3b;
  }

  .sr-bb .srt-fill-soccer-relegation-1 {
    fill: #fdd835;
  }

  .sr-bb .srt-stroke-soccer-relegation-1 {
    stroke: #fdd835;
  }

  .sr-bb .srt-fill-soccer-relegation-2 {
    fill: #ffb848;
  }

  .sr-bb .srt-stroke-soccer-relegation-2 {
    stroke: #ffb848;
  }

  .sr-bb .srt-fill-soccer-relegation-3 {
    fill: #ef6c00;
  }

  .sr-bb .srt-stroke-soccer-relegation-3 {
    stroke: #ef6c00;
  }

  .sr-bb .srt-fill-soccer-relegation-4 {
    fill: #e93a34;
  }

  .sr-bb .srt-stroke-soccer-relegation-4 {
    stroke: #e93a34;
  }

  .sr-bb .srt-fill-soccer-relegation-5 {
    fill: #941d1d;
  }

  .sr-bb .srt-stroke-soccer-relegation-5 {
    stroke: #941d1d;
  }

  .sr-bb .srt-fill-soccer-promotion-1 {
    fill: #51d151;
  }

  .sr-bb .srt-stroke-soccer-promotion-1 {
    stroke: #51d151;
  }

  .sr-bb .srt-fill-soccer-promotion-2 {
    fill: #1b911b;
  }

  .sr-bb .srt-stroke-soccer-promotion-2 {
    stroke: #1b911b;
  }

  .sr-bb .srt-fill-soccer-promotion-3 {
    fill: #0e8094;
  }

  .sr-bb .srt-stroke-soccer-promotion-3 {
    stroke: #0e8094;
  }

  .sr-bb .srt-fill-soccer-promotion-4 {
    fill: #0a6cce;
  }

  .sr-bb .srt-stroke-soccer-promotion-4 {
    stroke: #0a6cce;
  }

  .sr-bb .srt-fill-soccer-promotion-5 {
    fill: #4a9fe4;
  }

  .sr-bb .srt-stroke-soccer-promotion-5 {
    stroke: #4a9fe4;
  }

  .sr-bb .srt-nfl-timeout-1 {
    background-color: #f5a623;
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-nfl-timeout-2 {
    background-color: rgba(245, 166, 35, 0.3);
    color: #ffffff;
    border-color: rgba(255, 255, 255, 0.16);
  }

  .sr-bb .srt-nfl-penalty {
    background-color: #f4a621;
    color: #ffffff;
    border-color: #f4a621;
  }

  .sr-bb .srt-nfl-negative-yards-1 {
    background-color: #ac182e;
    color: #ffffff;
    border-color: #ac182e;
  }

  .sr-bb .srt-nfl-negative-yards-2 {
    background-color: #ac182e;
    color: #ffffff;
    border-color: #ac182e;
  }

  .sr-bb .srt-nfl-first-line {
    background-color: #4b90de;
    color: #ffffff;
    border-color: #4b90de;
  }

  .sr-bb .srt-nfl-ten-line {
    background-color: #f5a623;
    color: #ffffff;
    border-color: #f5a623;
  }

  .sr-bb .srt-fill-nfl-penalty {
    fill: #f4a621;
  }

  .sr-bb .srt-stroke-nfl-penalty {
    stroke: #f4a621;
  }

  .sr-bb .srt-fill-nfl-negative-yards-1 {
    fill: #ac182e;
  }

  .sr-bb .srt-stroke-nfl-negative-yards-1 {
    stroke: #ac182e;
  }

  .sr-bb .srt-fill-nfl-negative-yards-2 {
    fill: #ac182e;
  }

  .sr-bb .srt-stroke-nfl-negative-yards-2 {
    stroke: #ac182e;
  }

  .sr-bb .srt-fill-nfl-first-line {
    fill: #4b90de;
  }

  .sr-bb .srt-stroke-nfl-first-line {
    stroke: #4b90de;
  }

  .sr-bb .srt-fill-nfl-ten-line {
    fill: #f5a623;
  }

  .sr-bb .srt-stroke-nfl-ten-line {
    stroke: #f5a623;
  }

  .sr-bb .srt-mlb-run-1 {
    background-color: #009900;
    color: #ffffff;
    border-color: #009900;
  }

  .sr-bb .srt-mlb-run-2 {
    background-color: #ffffff;
    color: #009900;
    border-color: #009900;
  }

  .sr-bb .srt-mlb-hit-1 {
    background-color: #f7ab11;
    color: #000000;
    border-color: #f7ab11;
  }

  .sr-bb .srt-mlb-hit-2 {
    background-color: #ffffff;
    color: #f7ab11;
    border-color: #f7ab11;
  }

  .sr-bb .srt-mlb-hit-3 {
    background-color: #00a4ff;
    color: #ffffff;
    border-color: #00a4ff;
  }

  .sr-bb .srt-mlb-error-1 {
    background-color: #d0021b;
    color: #ffffff;
    border-color: #d0021b;
  }

  .sr-bb .srt-mlb-error-2 {
    background-color: #ffffff;
    color: #d0021b;
    border-color: #d0021b;
  }

  .sr-bb .srt-mlb-neutral-1 {
    background-color: #212121;
    color: #ffffff;
    border-color: #ffffff;
  }

  .sr-bb .srt-fill-mlb-base {
    fill: #00a4ff;
  }

  .sr-bb .srt-strole-mlb-base {
    fill: #00a4ff;
  }

  .sr-bb .srt-fill-change-increase {
    fill: red;
  }

  .sr-bb .srt-stroke-change-increase {
    stroke: red;
  }

  .sr-bb .srt-fill-change-decrease {
    fill: #ff8787;
  }

  .sr-bb .srt-stroke-change-decrease {
    stroke: #ff8787;
  }

  .sr-bb .srt-fill-text {
    fill: #000000;
  }

  .sr-bb .srt-fill-text-invert {
    fill: #ffffff;
  }

  .sr-bb .srt-fill-text-secondary {
    fill-opacity: 0.7;
  }

  .sr-bb .srt-fill-text-disabled {
    fill-opacity: 0.35;
  }

  .sr-bb .srt-fill-base-1 {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1 {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-1-active {
    fill: rgba(255, 0, 0, 0.12);
  }

  .sr-bb .srt-stroke-base-1-active {
    stroke: rgba(255, 0, 0, 0.12);
  }

  .sr-bb .srt-fill-base-1-active-2 {
    fill: #e6e6e6;
  }

  .sr-bb .srt-stroke-base-1-active-2 {
    stroke: #e6e6e6;
  }

  .sr-bb .srt-fill-base-1-primary {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1-primary {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-1-home {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1-home {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-1-away {
    fill: transparent;
  }

  .sr-bb .srt-stroke-base-1-away {
    stroke: transparent;
  }

  .sr-bb .srt-fill-base-2 {
    fill: currentColor;
  }

  .sr-bb .srt-stroke-base-2 {
    stroke: currentColor;
  }

  .sr-bb .srt-fill-base-2-active {
    fill: #ffe0e0;
  }

  .sr-bb .srt-stroke-base-2-active {
    stroke: #ffe0e0;
  }

  .sr-bb .srt-fill-base-2-hover {
    fill: #ffe0e0;
  }

  .sr-bb .srt-stroke-base-2-hover {
    stroke: #ffe0e0;
  }

  .sr-bb .srt-fill-base-3 {
    fill: #ffe0e0;
  }

  .sr-bb .srt-stroke-base-3 {
    stroke: #ffe0e0;
  }

  .sr-bb .srt-fill-base-3-active {
    fill: #ffd4d4;
  }

  .sr-bb .srt-stroke-base-3-active {
    stroke: #ffd4d4;
  }

  .sr-bb .srt-fill-base-3-hover {
    fill: #ffd4d4;
  }

  .sr-bb .srt-stroke-base-3-hover {
    stroke: #ffd4d4;
  }

  .sr-bb .srt-fill-primary-1 {
    fill: #ff0000;
  }

  .sr-bb .srt-stroke-primary-1 {
    stroke: #ff0000;
  }

  .sr-bb .srt-fill-primary-2 {
    fill: #b30000;
  }

  .sr-bb .srt-stroke-primary-2 {
    stroke: #b30000;
  }

  .sr-bb .srt-fill-primary-3 {
    fill: #ff1a1a;
  }

  .sr-bb .srt-stroke-primary-3 {
    stroke: #ff1a1a;
  }

  .sr-bb .srt-fill-primary-4 {
    fill: #ff6666;
  }

  .sr-bb .srt-stroke-primary-4 {
    stroke: #ff6666;
  }

  .sr-bb .srt-fill-primary-5 {
    fill: #ff6666;
  }

  .sr-bb .srt-stroke-primary-5 {
    stroke: #ff6666;
  }

  .sr-bb .srt-fill-primary-6 {
    fill: #940000;
  }

  .sr-bb .srt-stroke-primary-6 {
    stroke: #940000;
  }

  .sr-bb .srt-fill-primary-7 {
    fill: #ff0000;
  }

  .sr-bb .srt-stroke-primary-7 {
    stroke: #ff0000;
  }

  .sr-bb .srt-fill-primary-8 {
    fill: #ff0000;
  }

  .sr-bb .srt-stroke-primary-8 {
    stroke: #ff0000;
  }

  .sr-bb .srt-fill-primary-8-is-active-1 {
    fill: #ff1a1a;
  }

  .sr-bb .srt-stroke-primary-8-is-active-1 {
    stroke: #ff1a1a;
  }

  .sr-bb .srt-fill-primary-8-is-active-2 {
    fill: #ff1a1a;
  }

  .sr-bb .srt-stroke-primary-8-is-active-2 {
    stroke: #ff1a1a;
  }

  .sr-bb .srt-fill-primary-9 {
    fill: #ffb3b3;
  }

  .sr-bb .srt-stroke-primary-9 {
    stroke: #ffb3b3;
  }

  .sr-bb .srt-fill-primary-10 {
    fill: #ff3333;
  }

  .sr-bb .srt-stroke-primary-10 {
    stroke: #ff3333;
  }

  .sr-bb .srt-fill-primary-11 {
    fill: #ff1a1a;
  }

  .sr-bb .srt-stroke-primary-11 {
    stroke: #ff1a1a;
  }

  .sr-bb .srt-fill-primary-12 {
    fill: #ff0000;
  }

  .sr-bb .srt-stroke-primary-12 {
    stroke: #ff0000;
  }

  .sr-bb .srt-fill-home-1 {
    fill: #3f3f41;
  }

  .sr-bb .srt-stroke-home-1 {
    stroke: #3f3f41;
  }

  .sr-bb .srt-fill-home-2 {
    fill: #3f3f41;
  }

  .sr-bb .srt-stroke-home-2 {
    stroke: #3f3f41;
  }

  .sr-bb .srt-fill-home-3 {
    fill: #3f3f41;
  }

  .sr-bb .srt-stroke-home-3 {
    stroke: #3f3f41;
  }

  .sr-bb .srt-fill-home-4 {
    fill: #79797a;
  }

  .sr-bb .srt-stroke-home-4 {
    stroke: #79797a;
  }

  .sr-bb .srt-fill-home-5 {
    fill: #29292a;
  }

  .sr-bb .srt-stroke-home-5 {
    stroke: #29292a;
  }

  .sr-bb .srt-fill-away-1 {
    fill: #9c9c9c;
  }

  .sr-bb .srt-stroke-away-1 {
    stroke: #9c9c9c;
  }

  .sr-bb .srt-fill-away-2 {
    fill: #9c9c9c;
  }

  .sr-bb .srt-stroke-away-2 {
    stroke: #9c9c9c;
  }

  .sr-bb .srt-fill-away-3 {
    fill: #9c9c9c;
  }

  .sr-bb .srt-stroke-away-3 {
    stroke: #9c9c9c;
  }

  .sr-bb .srt-fill-away-4 {
    fill: #bababa;
  }

  .sr-bb .srt-stroke-away-4 {
    stroke: #bababa;
  }

  .sr-bb .srt-fill-away-5 {
    fill: #656565;
  }

  .sr-bb .srt-stroke-away-5 {
    stroke: #656565;
  }

  .sr-bb .srt-fill-neutral-1 {
    fill: #dedede;
  }

  .sr-bb .srt-stroke-neutral-1 {
    stroke: #dedede;
  }

  .sr-bb .srt-fill-neutral-2 {
    fill: #1a1a1a;
  }

  .sr-bb .srt-stroke-neutral-2 {
    stroke: #1a1a1a;
  }

  .sr-bb .srt-fill-neutral-3 {
    fill: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-stroke-neutral-3 {
    stroke: rgba(0, 0, 0, 0.12);
  }

  .sr-bb .srt-fill-neutral-4 {
    fill: #595959;
  }

  .sr-bb .srt-stroke-neutral-4 {
    stroke: #595959;
  }

  .sr-bb .srt-fill-neutral-5 {
    fill: #404040;
  }

  .sr-bb .srt-stroke-neutral-5 {
    stroke: #404040;
  }

  .sr-bb .srt-fill-neutral-6 {
    fill: #c2c2c2;
  }

  .sr-bb .srt-stroke-neutral-6 {
    stroke: #c2c2c2;
  }

  .sr-bb .srt-fill-neutral-7 {
    fill: #595959;
  }

  .sr-bb .srt-stroke-neutral-7 {
    stroke: #595959;
  }

  .sr-bb .srt-fill-neutral-8 {
    fill: #dedede;
  }

  .sr-bb .srt-stroke-neutral-8 {
    stroke: #dedede;
  }

  .sr-bb .srt-fill-neutral-9 {
    fill: #f0f0f0;
  }

  .sr-bb .srt-stroke-neutral-9 {
    stroke: #f0f0f0;
  }

  .sr-bb .srt-fill-neutral-10 {
    fill: #e0e0e0;
  }

  .sr-bb .srt-stroke-neutral-10 {
    stroke: #e0e0e0;
  }

  .sr-bb .srt-fill-neutral-11 {
    fill: #999999;
  }

  .sr-bb .srt-stroke-neutral-11 {
    stroke: #999999;
  }

  .sr-bb .srt-fill-neutral-12 {
    fill: #4d4d4d;
  }

  .sr-bb .srt-stroke-neutral-12 {
    stroke: #4d4d4d;
  }

  .sr-bb .srt-fill-neutral-13 {
    fill: #e6e6e6;
  }

  .sr-bb .srt-stroke-neutral-13 {
    stroke: #e6e6e6;
  }

  .sr-bb .srt-fill-win {
    fill: red;
  }

  .sr-bb .srt-stroke-win {
    stroke: red;
  }

  .sr-bb .srt-fill-draw {
    fill: #c2c2c2;
  }

  .sr-bb .srt-stroke-draw {
    stroke: #c2c2c2;
  }

  .sr-bb .srt-fill-lose {
    fill: #ff8787;
  }

  .sr-bb .srt-stroke-lose {
    stroke: #ff8787;
  }

  .sr-bb .srt-stop-base-1 {
    stop-color: transparent;
  }

  .sr-bb .srt-stop-primary-1 {
    stop-color: #ff0000;
  }

  .sr-bb .srt-stop-primary-2 {
    stop-color: #b30000;
  }

  .sr-bb .srt-stop-primary-3 {
    stop-color: #ff1a1a;
  }

  .sr-bb .srt-stop-primary-4 {
    stop-color: #ff6666;
  }

  .sr-bb .srt-stop-primary-5 {
    stop-color: #ff6666;
  }

  .sr-bb .srt-stop-primary-6 {
    stop-color: #940000;
  }

  .sr-bb .srt-stop-primary-7 {
    stop-color: #ff0000;
  }

  .sr-bb .srt-stop-primary-8 {
    stop-color: #ff0000;
  }

  .sr-bb .srt-stop-primary-9 {
    stop-color: #ffb3b3;
  }

  .sr-bb .srt-stop-primary-10 {
    stop-color: #ff3333;
  }

  .sr-bb .srt-stop-primary-11 {
    stop-color: #ff1a1a;
  }

  .sr-bb .srt-stop-primary-12 {
    stop-color: #ff0000;
  }

  .sr-bb .srt-stop-home-1 {
    stop-color: #3f3f41;
  }

  .sr-bb .srt-stop-away-1 {
    stop-color: #9c9c9c;
  }

  .sr-bb .srt-fill-neutral-14 {
    fill: #ffffff;
  }

  .sr-bb .srt-stroke-neutral-14 {
    stroke: #ffffff;
  }

  .sr-bb .srt-logo-powered-by-light {
    display: inline-block;
  }

  .sr-bb .srt-logo-powered-by-dark {
    display: none;
  }

  .sr-lmt-plus__footer-wrapper {
    display: none !important;
  }

  .sr-lmt-plus-f1__footer-wrapper {
    display: none !important;
  }

  .sr-lmt-plus-tabs__wrapper {
    background-color: #252525 !important;
    .sr-lmt-plus-tabs__tab-icon {
      fill: white !important;
    }
    .sr-lmt-plus-tabs__tab-name {
      color: white !important;
    }
    .sr-lmt-plus-tabs__border {
      background-color: white !important;
    }
  }

  .sr-lmt-plus__comp-wrapper {
    border-bottom-style: hidden !important;
  }

  .overrideTrackerCss {
    .sr-bb {
      font-family: 'Roboto', 'Noto', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
      text-align: left;
      background: #121213;
    }

    .sr-bb.sr-rtl {
      text-align: right;
    }

    .sr-bb .sr-bb {
      background: none;
    }

    .sr-bb .srt-base-1 {
      background-color: transparent;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-win {
      background-color: transparent;
      color: #36383e;
      border-color: #36383e;
    }

    .sr-bb .srt-base-1-draw {
      background-color: transparent;
      color: rgba(238, 242, 245, 0.4);
      border-color: rgba(238, 242, 245, 0.4);
    }

    .sr-bb .srt-base-1-lose {
      background-color: transparent;
      color: #36383e;
      border-color: #36383e;
    }

    .sr-bb .srt-base-1-is-active {
      background-color: rgba(255, 0, 3, 0.12);
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-is-active-2 {
      background-color: #28282a;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-is-hoverable:hover {
      background-color: rgba(255, 0, 3, 0.12);
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-primary {
      background-color: transparent;
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-home-1 {
      background-color: transparent;
      color: #36383e;
      border-color: #36383e;
    }

    .sr-bb .srt-base-1-away-1 {
      background-color: transparent;
      color: #36383e;
      border-color: #36383e;
    }

    .sr-bb .srt-base-1-home-2 {
      background-color: transparent;
      color: #36383e;
      border-color: #f86669;
    }

    .sr-bb .srt-base-1-away-2 {
      background-color: transparent;
      color: #36383e;
      border-color: #f86669;
    }

    .sr-bb .srt-base-1-home-3 {
      background-color: transparent;
      color: #36383e;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-away-3 {
      background-color: transparent;
      color: #36383e;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-home-4 {
      background-color: transparent;
      color: #2b2d31;
      border-color: #2b2d31;
    }

    .sr-bb .srt-base-1-away-4 {
      background-color: transparent;
      color: #2b2d31;
      border-color: #2b2d31;
    }

    .sr-bb .srt-base-1-home-5 {
      background-color: transparent;
      color: #76797e;
      border-color: #76797e;
    }

    .sr-bb .srt-base-1-away-5 {
      background-color: transparent;
      color: #76797e;
      border-color: #76797e;
    }

    .sr-bb .srt-base-1-background {
      background-color: #121213;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-2 {
      background-color: #121213;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-2-is-active {
      background-color: #2e1011;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-2-is-hoverable:hover {
      background-color: #2e1011;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-3 {
      background-color: #2e1011;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-3-is-active {
      background-color: #3a0f10;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-3-is-hoverable:hover {
      background-color: #3a0f10;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-3-background {
      background-color: #121213;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-4 {
      background-color: #1e1112;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-5-is-active {
      background-color: #500d0f;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-5-is-hoverable:hover {
      background-color: #500d0f;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-6 {
      background-color: transparent;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.3);
    }

    .sr-bb .srt-primary-1 {
      background-color: #ff0003;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-1-is-active {
      background-color: #ff1a1c;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-1-is-hoverable:hover {
      background-color: #ff1a1c;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-1-is-disabled {
      background-color: #ff3335;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-2 {
      background-color: #fa494c;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-3 {
      background-color: #ff1a1c;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-4 {
      background-color: #a00709;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-5 {
      background-color: #a00709;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-5-is-hoverable:hover {
      background-color: #ff0003;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-6 {
      background-color: #f86669;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-7 {
      background-color: #ff0003;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-8 {
      background-color: #ff0003;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-8-is-active-1 {
      background-color: #ff1a1c;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-8-is-active-2 {
      background-color: #ff1a1c;
      color: #ffffff;
      border-color: #121213;
    }

    .sr-bb .srt-primary-9 {
      background-color: #590d0e;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-primary-10 {
      background-color: #d00406;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-11 {
      background-color: #ff1a1c;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-primary-12 {
      background-color: #ff0003;
      color: #ffffff;
      border-color: #ffffff;
    }

    .sr-bb .srt-primary-13 {
      background-color: #1e1112;
      color: #ffffff;
      border-color: rgba(255, 0, 3, 0.3);
    }

    .sr-bb .srt-base-1-primary-1 {
      background-color: transparent;
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-primary-2 {
      background-color: transparent;
      color: #fa494c;
      border-color: #fa494c;
    }

    .sr-bb .srt-base-1-primary-3 {
      background-color: transparent;
      color: #ff1a1c;
      border-color: #ff1a1c;
    }

    .sr-bb .srt-base-1-primary-4 {
      background-color: transparent;
      color: #a00709;
      border-color: #a00709;
    }

    .sr-bb .srt-base-1-primary-5 {
      background-color: transparent;
      color: #a00709;
      border-color: #a00709;
    }

    .sr-bb .srt-base-1-primary-6 {
      background-color: transparent;
      color: #f86669;
      border-color: #f86669;
    }

    .sr-bb .srt-base-1-primary-7 {
      background-color: transparent;
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-primary-8 {
      background-color: transparent;
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-primary-9 {
      background-color: transparent;
      color: #590d0e;
      border-color: #590d0e;
    }

    .sr-bb .srt-base-1-primary-10 {
      background-color: transparent;
      color: #d00406;
      border-color: #d00406;
    }

    .sr-bb .srt-base-1-primary-11 {
      background-color: transparent;
      color: #ff1a1c;
      border-color: #ff1a1c;
    }

    .sr-bb .srt-base-1-primary-13 {
      background-color: #121213;
      color: #1e1112;
      border-color: rgba(255, 0, 3, 0.3);
    }

    .sr-bb .srt-base-1-neutral-1 {
      background-color: transparent;
      color: #2f2f30;
      border-color: #2f2f30;
    }

    .sr-bb .srt-base-1-neutral-2 {
      background-color: transparent;
      color: #d8dcde;
      border-color: #d8dcde;
    }

    .sr-bb .srt-base-1-neutral-3 {
      background-color: transparent;
      color: rgba(238, 242, 245, 0.12);
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-neutral-4 {
      background-color: transparent;
      color: #a1a4a6;
      border-color: #a1a4a6;
    }

    .sr-bb .srt-base-1-neutral-5 {
      background-color: transparent;
      color: #b7babd;
      border-color: #b7babd;
    }

    .sr-bb .srt-base-1-neutral-6 {
      background-color: transparent;
      color: #474849;
      border-color: #474849;
    }

    .sr-bb .srt-base-1-neutral-7 {
      background-color: transparent;
      color: #a1a4a6;
      border-color: #a1a4a6;
    }

    .sr-bb .srt-base-1-neutral-8 {
      background-color: transparent;
      color: #2f2f30;
      border-color: #2f2f30;
    }

    .sr-bb .srt-base-1-neutral-9 {
      background-color: transparent;
      color: #1f1f21;
      border-color: #1f1f21;
    }

    .sr-bb .srt-base-1-neutral-10 {
      background-color: transparent;
      color: #2c2d2e;
      border-color: #2c2d2e;
    }

    .sr-bb .srt-base-1-neutral-11 {
      background-color: transparent;
      color: #6a6c6d;
      border-color: #6a6c6d;
    }

    .sr-bb .srt-base-1-neutral-12 {
      background-color: transparent;
      color: #acafb1;
      border-color: #acafb1;
    }

    .sr-bb .srt-base-1-neutral-13 {
      background-color: transparent;
      color: #28282a;
      border-color: #28282a;
    }

    .sr-bb .srt-base-1-is-active-primary {
      background-color: rgba(255, 0, 3, 0.12);
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-is-active-home-1 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #36383e;
      border-color: #36383e;
    }

    .sr-bb .srt-base-1-is-active-away-1 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #36383e;
      border-color: #36383e;
    }

    .sr-bb .srt-base-1-is-active-home-2 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #36383e;
      border-color: #f86669;
    }

    .sr-bb .srt-base-1-is-active-away-2 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #36383e;
      border-color: #f86669;
    }

    .sr-bb .srt-base-1-is-active-home-3 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #36383e;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-is-active-away-3 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #36383e;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-is-active-home-4 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #2b2d31;
      border-color: #2b2d31;
    }

    .sr-bb .srt-base-1-is-active-away-4 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #2b2d31;
      border-color: #2b2d31;
    }

    .sr-bb .srt-base-1-is-active-home-5 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #76797e;
      border-color: #76797e;
    }

    .sr-bb .srt-base-1-is-active-away-5 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #76797e;
      border-color: #76797e;
    }

    .sr-bb .srt-base-1-is-active-primary-1 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-is-active-primary-2 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #fa494c;
      border-color: #fa494c;
    }

    .sr-bb .srt-base-1-is-active-primary-3 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #ff1a1c;
      border-color: #ff1a1c;
    }

    .sr-bb .srt-base-1-is-active-primary-4 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #a00709;
      border-color: #a00709;
    }

    .sr-bb .srt-base-1-is-active-primary-5 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #a00709;
      border-color: #a00709;
    }

    .sr-bb .srt-base-1-is-active-primary-6 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #f86669;
      border-color: #f86669;
    }

    .sr-bb .srt-base-1-is-active-primary-7 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-is-active-primary-8 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #ff0003;
      border-color: #ff0003;
    }

    .sr-bb .srt-base-1-is-active-primary-9 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #590d0e;
      border-color: #590d0e;
    }

    .sr-bb .srt-base-1-is-active-primary-10 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #d00406;
      border-color: #d00406;
    }

    .sr-bb .srt-base-1-is-active-primary-11 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #ff1a1c;
      border-color: #ff1a1c;
    }

    .sr-bb .srt-base-1-is-active-neutral-1 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #2f2f30;
      border-color: #2f2f30;
    }

    .sr-bb .srt-base-1-is-active-neutral-2 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #d8dcde;
      border-color: #d8dcde;
    }

    .sr-bb .srt-base-1-is-active-neutral-3 {
      background-color: rgba(255, 0, 3, 0.12);
      color: rgba(238, 242, 245, 0.12);
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-base-1-is-active-neutral-4 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #a1a4a6;
      border-color: #a1a4a6;
    }

    .sr-bb .srt-base-1-is-active-neutral-5 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #b7babd;
      border-color: #b7babd;
    }

    .sr-bb .srt-base-1-is-active-neutral-6 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #474849;
      border-color: #474849;
    }

    .sr-bb .srt-base-1-is-active-neutral-7 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #a1a4a6;
      border-color: #a1a4a6;
    }

    .sr-bb .srt-base-1-is-active-neutral-8 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #2f2f30;
      border-color: #2f2f30;
    }

    .sr-bb .srt-base-1-is-active-neutral-9 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #1f1f21;
      border-color: #1f1f21;
    }

    .sr-bb .srt-base-1-is-active-neutral-10 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #2c2d2e;
      border-color: #2c2d2e;
    }

    .sr-bb .srt-base-1-is-active-neutral-11 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #6a6c6d;
      border-color: #6a6c6d;
    }

    .sr-bb .srt-base-1-is-active-neutral-12 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #acafb1;
      border-color: #acafb1;
    }

    .sr-bb .srt-base-1-is-active-neutral-13 {
      background-color: rgba(255, 0, 3, 0.12);
      color: #28282a;
      border-color: #28282a;
    }

    .sr-bb .srt-home-1 {
      background-color: #36383e;
      color: #ffffff;
      border-color: #36383e;
    }

    .sr-bb .srt-away-1 {
      background-color: #36383e;
      color: #ffffff;
      border-color: #36383e;
    }

    .sr-bb .srt-home-2 {
      background-color: #36383e;
      color: #ffffff;
      border-color: #f86669;
    }

    .sr-bb .srt-away-2 {
      background-color: #36383e;
      color: #ffffff;
      border-color: #f86669;
    }

    .sr-bb .srt-home-3 {
      background-color: #36383e;
      color: #ffffff;
      border-color: #121213;
    }

    .sr-bb .srt-away-3 {
      background-color: #36383e;
      color: #ffffff;
      border-color: #121213;
    }

    .sr-bb .srt-home-4 {
      background-color: #2b2d31;
      color: #ffffff;
      border-color: #2b2d31;
    }

    .sr-bb .srt-away-4 {
      background-color: #2b2d31;
      color: #ffffff;
      border-color: #2b2d31;
    }

    .sr-bb .srt-home-5 {
      background-color: #76797e;
      color: #ffffff;
      border-color: #76797e;
    }

    .sr-bb .srt-away-5 {
      background-color: #76797e;
      color: #ffffff;
      border-color: #76797e;
    }

    .sr-bb .srt-neutral-1 {
      background-color: #2f2f30;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-2 {
      background-color: #d8dcde;
      color: #000000;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-neutral-3 {
      background-color: rgba(238, 242, 245, 0.12);
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-4 {
      background-color: #a1a4a6;
      color: #000000;
      border-color: rgba(0, 0, 0, 0.16);
    }

    .sr-bb .srt-neutral-5 {
      background-color: #b7babd;
      color: #000000;
      border-color: rgba(0, 0, 0, 0.16);
    }

    .sr-bb .srt-neutral-6 {
      background-color: #474849;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-7 {
      background-color: #a1a4a6;
      color: #000000;
      border-color: rgba(0, 0, 0, 0.16);
    }

    .sr-bb .srt-neutral-8 {
      background-color: #2f2f30;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-9 {
      background-color: #1f1f21;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-10 {
      background-color: #2c2d2e;
      color: rgba(238, 242, 245, 0.82);
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-11 {
      background-color: #6a6c6d;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-neutral-12 {
      background-color: #acafb1;
      color: #000000;
      border-color: rgba(0, 0, 0, 0.16);
    }

    .sr-bb .srt-neutral-13 {
      background-color: #28282a;
      color: #eef2f5;
      border-color: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-win {
      background-color: #36383e;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-draw {
      background-color: rgba(238, 242, 245, 0.4);
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-lose {
      background-color: #36383e;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-text-secondary {
      opacity: 0.8;
      -webkit-font-smoothing: antialiased;
    }

    .sr-bb .srt-text-disabled {
      opacity: 0.6;
    }

    .sr-bb .srt-text-tertiary {
      opacity: 0.7;
    }

    .sr-bb .srt-primary-1 .srt-text-secondary,
    .sr-bb .srt-primary-1.srt-text-secondary,
    .sr-bb .srt-primary-1-is-active .srt-text-secondary,
    .sr-bb .srt-primary-1-is-active.srt-text-secondary,
    .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-secondary,
    .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-secondary,
    .sr-bb .srt-primary-1-is-disabled .srt-text-secondary,
    .sr-bb .srt-primary-1-is-disabled.srt-text-secondary,
    .sr-bb .srt-primary-2 .srt-text-secondary,
    .sr-bb .srt-primary-2.srt-text-secondary,
    .sr-bb .srt-primary-3 .srt-text-secondary,
    .sr-bb .srt-primary-3.srt-text-secondary,
    .sr-bb .srt-primary-4 .srt-text-secondary,
    .sr-bb .srt-primary-4.srt-text-secondary,
    .sr-bb .srt-primary-5 .srt-text-secondary,
    .sr-bb .srt-primary-5.srt-text-secondary,
    .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-secondary,
    .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-secondary,
    .sr-bb .srt-primary-6 .srt-text-secondary,
    .sr-bb .srt-primary-6.srt-text-secondary,
    .sr-bb .srt-primary-7 .srt-text-secondary,
    .sr-bb .srt-primary-7.srt-text-secondary,
    .sr-bb .srt-primary-8 .srt-text-secondary,
    .sr-bb .srt-primary-8.srt-text-secondary,
    .sr-bb .srt-primary-8-is-active-1 .srt-text-secondary,
    .sr-bb .srt-primary-8-is-active-1.srt-text-secondary,
    .sr-bb .srt-primary-8-is-active-2 .srt-text-secondary,
    .sr-bb .srt-primary-8-is-active-2.srt-text-secondary,
    .sr-bb .srt-primary-9 .srt-text-secondary,
    .sr-bb .srt-primary-9.srt-text-secondary,
    .sr-bb .srt-primary-10 .srt-text-secondary,
    .sr-bb .srt-primary-10.srt-text-secondary,
    .sr-bb .srt-primary-11 .srt-text-secondary,
    .sr-bb .srt-primary-11.srt-text-secondary,
    .sr-bb .srt-primary-12 .srt-text-secondary,
    .sr-bb .srt-primary-12.srt-text-secondary,
    .sr-bb .srt-primary-13 .srt-text-secondary,
    .sr-bb .srt-primary-13.srt-text-secondary {
      opacity: 0.8;
      -webkit-font-smoothing: antialiased;
    }

    .sr-bb .srt-primary-1 .srt-text-disabled,
    .sr-bb .srt-primary-1.srt-text-disabled,
    .sr-bb .srt-primary-1-is-active .srt-text-disabled,
    .sr-bb .srt-primary-1-is-active.srt-text-disabled,
    .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-disabled,
    .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-disabled,
    .sr-bb .srt-primary-1-is-disabled .srt-text-disabled,
    .sr-bb .srt-primary-1-is-disabled.srt-text-disabled,
    .sr-bb .srt-primary-2 .srt-text-disabled,
    .sr-bb .srt-primary-2.srt-text-disabled,
    .sr-bb .srt-primary-3 .srt-text-disabled,
    .sr-bb .srt-primary-3.srt-text-disabled,
    .sr-bb .srt-primary-4 .srt-text-disabled,
    .sr-bb .srt-primary-4.srt-text-disabled,
    .sr-bb .srt-primary-5 .srt-text-disabled,
    .sr-bb .srt-primary-5.srt-text-disabled,
    .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-disabled,
    .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-disabled,
    .sr-bb .srt-primary-6 .srt-text-disabled,
    .sr-bb .srt-primary-6.srt-text-disabled,
    .sr-bb .srt-primary-7 .srt-text-disabled,
    .sr-bb .srt-primary-7.srt-text-disabled,
    .sr-bb .srt-primary-8 .srt-text-disabled,
    .sr-bb .srt-primary-8.srt-text-disabled,
    .sr-bb .srt-primary-8-is-active-1 .srt-text-disabled,
    .sr-bb .srt-primary-8-is-active-1.srt-text-disabled,
    .sr-bb .srt-primary-8-is-active-2 .srt-text-disabled,
    .sr-bb .srt-primary-8-is-active-2.srt-text-disabled,
    .sr-bb .srt-primary-9 .srt-text-disabled,
    .sr-bb .srt-primary-9.srt-text-disabled,
    .sr-bb .srt-primary-10 .srt-text-disabled,
    .sr-bb .srt-primary-10.srt-text-disabled,
    .sr-bb .srt-primary-11 .srt-text-disabled,
    .sr-bb .srt-primary-11.srt-text-disabled,
    .sr-bb .srt-primary-12 .srt-text-disabled,
    .sr-bb .srt-primary-12.srt-text-disabled,
    .sr-bb .srt-primary-13 .srt-text-disabled,
    .sr-bb .srt-primary-13.srt-text-disabled {
      opacity: 0.6;
    }

    .sr-bb .srt-primary-1 .srt-text-tertiary,
    .sr-bb .srt-primary-1.srt-text-tertiary,
    .sr-bb .srt-primary-1-is-active .srt-text-tertiary,
    .sr-bb .srt-primary-1-is-active.srt-text-tertiary,
    .sr-bb .srt-primary-1-is-hoverable:hover .srt-text-tertiary,
    .sr-bb .srt-primary-1-is-hoverable:hover.srt-text-tertiary,
    .sr-bb .srt-primary-1-is-disabled .srt-text-tertiary,
    .sr-bb .srt-primary-1-is-disabled.srt-text-tertiary,
    .sr-bb .srt-primary-2 .srt-text-tertiary,
    .sr-bb .srt-primary-2.srt-text-tertiary,
    .sr-bb .srt-primary-3 .srt-text-tertiary,
    .sr-bb .srt-primary-3.srt-text-tertiary,
    .sr-bb .srt-primary-4 .srt-text-tertiary,
    .sr-bb .srt-primary-4.srt-text-tertiary,
    .sr-bb .srt-primary-5 .srt-text-tertiary,
    .sr-bb .srt-primary-5.srt-text-tertiary,
    .sr-bb .srt-primary-5-is-hoverable:hover .srt-text-tertiary,
    .sr-bb .srt-primary-5-is-hoverable:hover.srt-text-tertiary,
    .sr-bb .srt-primary-6 .srt-text-tertiary,
    .sr-bb .srt-primary-6.srt-text-tertiary,
    .sr-bb .srt-primary-7 .srt-text-tertiary,
    .sr-bb .srt-primary-7.srt-text-tertiary,
    .sr-bb .srt-primary-8 .srt-text-tertiary,
    .sr-bb .srt-primary-8.srt-text-tertiary,
    .sr-bb .srt-primary-8-is-active-1 .srt-text-tertiary,
    .sr-bb .srt-primary-8-is-active-1.srt-text-tertiary,
    .sr-bb .srt-primary-8-is-active-2 .srt-text-tertiary,
    .sr-bb .srt-primary-8-is-active-2.srt-text-tertiary,
    .sr-bb .srt-primary-9 .srt-text-tertiary,
    .sr-bb .srt-primary-9.srt-text-tertiary,
    .sr-bb .srt-primary-10 .srt-text-tertiary,
    .sr-bb .srt-primary-10.srt-text-tertiary,
    .sr-bb .srt-primary-11 .srt-text-tertiary,
    .sr-bb .srt-primary-11.srt-text-tertiary,
    .sr-bb .srt-primary-12 .srt-text-tertiary,
    .sr-bb .srt-primary-12.srt-text-tertiary,
    .sr-bb .srt-primary-13 .srt-text-tertiary,
    .sr-bb .srt-primary-13.srt-text-tertiary {
      opacity: 0.7;
    }

    .sr-bb .srt-icon {
      opacity: 0.33;
    }

    .sr-bb .srt-icon-secondary {
      opacity: 0.7;
    }

    .sr-bb .srt-elevation-1 {
      box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2), 0px 1px 3px 0px rgba(0, 0, 0, 0.1);
    }

    .sr-bb .srt-elevation-2 {
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.23), 0px 3px 6px 0px rgba(0, 0, 0, 0.16);
    }

    .sr-bb .srt-elevation-3 {
      box-shadow: 0px 6px 6px 0px rgba(0, 0, 0, 0.26), 0px 10px 20px 0px rgba(0, 0, 0, 0.19);
    }

    .sr-bb .srt-elevation-center-2 {
      box-shadow: 0 1px 5px rgba(0, 0, 0, 0.23), 0 1px 5px rgba(0, 0, 0, 0.16);
    }

    .sr-bb .srt-inset-top-1 {
      box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.23);
    }

    .sr-bb .srt-inset-bottom-1 {
      box-shadow: inset 0 -1px 2px 0 rgba(0, 0, 0, 0.23);
    }

    .sr-bb .srt-inset-top-2 {
      box-shadow: inset 0 3px 6px 0 rgba(0, 0, 0, 0.23);
    }

    .sr-bb .srt-inset-bottom-2 {
      box-shadow: inset 0 -3px 6px 0 rgba(0, 0, 0, 0.23);
    }

    .sr-bb .srt-inset-top-3 {
      box-shadow: inset 0 6px 6px 0 rgba(0, 0, 0, 0.23);
    }

    .sr-bb .srt-inset-bottom-3 {
      box-shadow: inset 0 -6px 6px 0 rgba(0, 0, 0, 0.23);
    }

    .sr-bb .srt-fill-blue-card {
      fill: #2579ad;
    }

    .sr-bb .srt-stroke-blue-card {
      stroke: #2579ad;
    }

    .sr-bb .srt-fill-soccer-yellow-card {
      fill: #ffbf00;
    }

    .sr-bb .srt-stroke-soccer-yellow-card {
      stroke: #ffbf00;
    }

    .sr-bb .srt-fill-soccer-red-card {
      fill: #e43b3b;
    }

    .sr-bb .srt-stroke-soccer-red-card {
      stroke: #e43b3b;
    }

    .sr-bb .srt-stroke-soccer-substitution-in {
      stroke: #4fbe30;
      fill: transparent;
    }

    .sr-bb .srt-fill-soccer-substitution-in {
      fill: #4fbe30;
    }

    .sr-bb .srt-stroke-soccer-substitution-out {
      stroke: #e43b3b;
      fill: transparent;
    }

    .sr-bb .srt-fill-soccer-substitution-out {
      fill: #e43b3b;
    }

    .sr-bb .srt-stroke-soccer-own-goal {
      stroke: #e43b3b;
      fill: transparent;
    }

    .sr-bb .srt-fill-soccer-own-goal {
      fill: #e43b3b;
    }

    .sr-bb .srt-fill-soccer-relegation-1 {
      fill: #fdd835;
    }

    .sr-bb .srt-stroke-soccer-relegation-1 {
      stroke: #fdd835;
    }

    .sr-bb .srt-fill-soccer-relegation-2 {
      fill: #ffb848;
    }

    .sr-bb .srt-stroke-soccer-relegation-2 {
      stroke: #ffb848;
    }

    .sr-bb .srt-fill-soccer-relegation-3 {
      fill: #ef6c00;
    }

    .sr-bb .srt-stroke-soccer-relegation-3 {
      stroke: #ef6c00;
    }

    .sr-bb .srt-fill-soccer-relegation-4 {
      fill: #e93a34;
    }

    .sr-bb .srt-stroke-soccer-relegation-4 {
      stroke: #e93a34;
    }

    .sr-bb .srt-fill-soccer-relegation-5 {
      fill: #941d1d;
    }

    .sr-bb .srt-stroke-soccer-relegation-5 {
      stroke: #941d1d;
    }

    .sr-bb .srt-fill-soccer-promotion-1 {
      fill: #51d151;
    }

    .sr-bb .srt-stroke-soccer-promotion-1 {
      stroke: #51d151;
    }

    .sr-bb .srt-fill-soccer-promotion-2 {
      fill: #1b911b;
    }

    .sr-bb .srt-stroke-soccer-promotion-2 {
      stroke: #1b911b;
    }

    .sr-bb .srt-fill-soccer-promotion-3 {
      fill: #0e8094;
    }

    .sr-bb .srt-stroke-soccer-promotion-3 {
      stroke: #0e8094;
    }

    .sr-bb .srt-fill-soccer-promotion-4 {
      fill: #0a6cce;
    }

    .sr-bb .srt-stroke-soccer-promotion-4 {
      stroke: #0a6cce;
    }

    .sr-bb .srt-fill-soccer-promotion-5 {
      fill: #4a9fe4;
    }

    .sr-bb .srt-stroke-soccer-promotion-5 {
      stroke: #4a9fe4;
    }

    .sr-bb .srt-nfl-timeout-1 {
      background-color: #f5a623;
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-nfl-timeout-2 {
      background-color: rgba(245, 166, 35, 0.3);
      color: #ffffff;
      border-color: rgba(255, 255, 255, 0.16);
    }

    .sr-bb .srt-nfl-penalty {
      background-color: #f4a621;
      color: #ffffff;
      border-color: #f4a621;
    }

    .sr-bb .srt-nfl-negative-yards-1 {
      background-color: #ac182e;
      color: #ffffff;
      border-color: #ac182e;
    }

    .sr-bb .srt-nfl-negative-yards-2 {
      background-color: #ac182e;
      color: #ffffff;
      border-color: #ac182e;
    }

    .sr-bb .srt-nfl-first-line {
      background-color: #4b90de;
      color: #ffffff;
      border-color: #4b90de;
    }

    .sr-bb .srt-nfl-ten-line {
      background-color: #f5a623;
      color: #ffffff;
      border-color: #f5a623;
    }

    .sr-bb .srt-fill-nfl-penalty {
      fill: #f4a621;
    }

    .sr-bb .srt-stroke-nfl-penalty {
      stroke: #f4a621;
    }

    .sr-bb .srt-fill-nfl-negative-yards-1 {
      fill: #ac182e;
    }

    .sr-bb .srt-stroke-nfl-negative-yards-1 {
      stroke: #ac182e;
    }

    .sr-bb .srt-fill-nfl-negative-yards-2 {
      fill: #ac182e;
    }

    .sr-bb .srt-stroke-nfl-negative-yards-2 {
      stroke: #ac182e;
    }

    .sr-bb .srt-fill-nfl-first-line {
      fill: #4b90de;
    }

    .sr-bb .srt-stroke-nfl-first-line {
      stroke: #4b90de;
    }

    .sr-bb .srt-fill-nfl-ten-line {
      fill: #f5a623;
    }

    .sr-bb .srt-stroke-nfl-ten-line {
      stroke: #f5a623;
    }

    .sr-bb .srt-mlb-run-1 {
      background-color: #009900;
      color: #ffffff;
      border-color: #009900;
    }

    .sr-bb .srt-mlb-run-2 {
      background-color: #ffffff;
      color: #009900;
      border-color: #009900;
    }

    .sr-bb .srt-mlb-hit-1 {
      background-color: #f7ab11;
      color: #eef2f5;
      border-color: #f7ab11;
    }

    .sr-bb .srt-mlb-hit-2 {
      background-color: #ffffff;
      color: #f7ab11;
      border-color: #f7ab11;
    }

    .sr-bb .srt-mlb-hit-3 {
      background-color: #00a4ff;
      color: #ffffff;
      border-color: #00a4ff;
    }

    .sr-bb .srt-mlb-error-1 {
      background-color: #d0021b;
      color: #ffffff;
      border-color: #d0021b;
    }

    .sr-bb .srt-mlb-error-2 {
      background-color: #ffffff;
      color: #d0021b;
      border-color: #d0021b;
    }

    .sr-bb .srt-mlb-neutral-1 {
      background-color: #212121;
      color: #ffffff;
      border-color: #ffffff;
    }

    .sr-bb .srt-fill-mlb-base {
      fill: #00a4ff;
    }

    .sr-bb .srt-strole-mlb-base {
      fill: #00a4ff;
    }

    .sr-bb .srt-fill-change-increase {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-change-increase {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-change-decrease {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-change-decrease {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-text {
      fill: #eef2f5;
    }

    .sr-bb .srt-fill-text-invert {
      fill: #ffffff;
    }

    .sr-bb .srt-fill-text-secondary {
      fill-opacity: 0.8;
    }

    .sr-bb .srt-fill-text-disabled {
      fill-opacity: 0.6;
    }

    .sr-bb .srt-fill-base-1 {
      fill: transparent;
    }

    .sr-bb .srt-stroke-base-1 {
      stroke: transparent;
    }

    .sr-bb .srt-fill-base-1-active {
      fill: rgba(255, 0, 3, 0.12);
    }

    .sr-bb .srt-stroke-base-1-active {
      stroke: rgba(255, 0, 3, 0.12);
    }

    .sr-bb .srt-fill-base-1-active-2 {
      fill: #28282a;
    }

    .sr-bb .srt-stroke-base-1-active-2 {
      stroke: #28282a;
    }

    .sr-bb .srt-fill-base-1-primary {
      fill: transparent;
    }

    .sr-bb .srt-stroke-base-1-primary {
      stroke: transparent;
    }

    .sr-bb .srt-fill-base-1-home {
      fill: transparent;
    }

    .sr-bb .srt-stroke-base-1-home {
      stroke: transparent;
    }

    .sr-bb .srt-fill-base-1-away {
      fill: transparent;
    }

    .sr-bb .srt-stroke-base-1-away {
      stroke: transparent;
    }

    .sr-bb .srt-fill-base-2 {
      fill: currentColor;
    }

    .sr-bb .srt-stroke-base-2 {
      stroke: currentColor;
    }

    .sr-bb .srt-fill-base-2-active {
      fill: #2e1011;
    }

    .sr-bb .srt-stroke-base-2-active {
      stroke: #2e1011;
    }

    .sr-bb .srt-fill-base-2-hover {
      fill: #2e1011;
    }

    .sr-bb .srt-stroke-base-2-hover {
      stroke: #2e1011;
    }

    .sr-bb .srt-fill-base-3 {
      fill: #2e1011;
    }

    .sr-bb .srt-stroke-base-3 {
      stroke: #2e1011;
    }

    .sr-bb .srt-fill-base-3-active {
      fill: #3a0f10;
    }

    .sr-bb .srt-stroke-base-3-active {
      stroke: #3a0f10;
    }

    .sr-bb .srt-fill-base-3-hover {
      fill: #3a0f10;
    }

    .sr-bb .srt-stroke-base-3-hover {
      stroke: #3a0f10;
    }

    .sr-bb .srt-fill-primary-1 {
      fill: #ff0003;
    }

    .sr-bb .srt-stroke-primary-1 {
      stroke: #ff0003;
    }

    .sr-bb .srt-fill-primary-2 {
      fill: #fa494c;
    }

    .sr-bb .srt-stroke-primary-2 {
      stroke: #fa494c;
    }

    .sr-bb .srt-fill-primary-3 {
      fill: #ff1a1c;
    }

    .sr-bb .srt-stroke-primary-3 {
      stroke: #ff1a1c;
    }

    .sr-bb .srt-fill-primary-4 {
      fill: #a00709;
    }

    .sr-bb .srt-stroke-primary-4 {
      stroke: #a00709;
    }

    .sr-bb .srt-fill-primary-5 {
      fill: #a00709;
    }

    .sr-bb .srt-stroke-primary-5 {
      stroke: #a00709;
    }

    .sr-bb .srt-fill-primary-6 {
      fill: #f86669;
    }

    .sr-bb .srt-stroke-primary-6 {
      stroke: #f86669;
    }

    .sr-bb .srt-fill-primary-7 {
      fill: #ff0003;
    }

    .sr-bb .srt-stroke-primary-7 {
      stroke: #ff0003;
    }

    .sr-bb .srt-fill-primary-8 {
      fill: #ff0003;
    }

    .sr-bb .srt-stroke-primary-8 {
      stroke: #ff0003;
    }

    .sr-bb .srt-fill-primary-8-is-active-1 {
      fill: #ff1a1c;
    }

    .sr-bb .srt-stroke-primary-8-is-active-1 {
      stroke: #ff1a1c;
    }

    .sr-bb .srt-fill-primary-8-is-active-2 {
      fill: #ff1a1c;
    }

    .sr-bb .srt-stroke-primary-8-is-active-2 {
      stroke: #ff1a1c;
    }

    .sr-bb .srt-fill-primary-9 {
      fill: #590d0e;
    }

    .sr-bb .srt-stroke-primary-9 {
      stroke: #590d0e;
    }

    .sr-bb .srt-fill-primary-10 {
      fill: #d00406;
    }

    .sr-bb .srt-stroke-primary-10 {
      stroke: #d00406;
    }

    .sr-bb .srt-fill-primary-11 {
      fill: #ff1a1c;
    }

    .sr-bb .srt-stroke-primary-11 {
      stroke: #ff1a1c;
    }

    .sr-bb .srt-fill-primary-12 {
      fill: #ff0003;
    }

    .sr-bb .srt-stroke-primary-12 {
      stroke: #ff0003;
    }

    .sr-bb .srt-fill-home-1 {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-home-1 {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-home-2 {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-home-2 {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-home-3 {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-home-3 {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-home-4 {
      fill: #2b2d31;
    }

    .sr-bb .srt-stroke-home-4 {
      stroke: #2b2d31;
    }

    .sr-bb .srt-fill-home-5 {
      fill: #76797e;
    }

    .sr-bb .srt-stroke-home-5 {
      stroke: #76797e;
    }

    .sr-bb .srt-fill-away-1 {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-away-1 {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-away-2 {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-away-2 {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-away-3 {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-away-3 {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-away-4 {
      fill: #2b2d31;
    }

    .sr-bb .srt-stroke-away-4 {
      stroke: #2b2d31;
    }

    .sr-bb .srt-fill-away-5 {
      fill: #76797e;
    }

    .sr-bb .srt-stroke-away-5 {
      stroke: #76797e;
    }

    .sr-bb .srt-fill-neutral-1 {
      fill: #2f2f30;
    }

    .sr-bb .srt-stroke-neutral-1 {
      stroke: #2f2f30;
    }

    .sr-bb .srt-fill-neutral-2 {
      fill: #d8dcde;
    }

    .sr-bb .srt-stroke-neutral-2 {
      stroke: #d8dcde;
    }

    .sr-bb .srt-fill-neutral-3 {
      fill: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-stroke-neutral-3 {
      stroke: rgba(238, 242, 245, 0.12);
    }

    .sr-bb .srt-fill-neutral-4 {
      fill: #a1a4a6;
    }

    .sr-bb .srt-stroke-neutral-4 {
      stroke: #a1a4a6;
    }

    .sr-bb .srt-fill-neutral-5 {
      fill: #b7babd;
    }

    .sr-bb .srt-stroke-neutral-5 {
      stroke: #b7babd;
    }

    .sr-bb .srt-fill-neutral-6 {
      fill: #474849;
    }

    .sr-bb .srt-stroke-neutral-6 {
      stroke: #474849;
    }

    .sr-bb .srt-fill-neutral-7 {
      fill: #a1a4a6;
    }

    .sr-bb .srt-stroke-neutral-7 {
      stroke: #a1a4a6;
    }

    .sr-bb .srt-fill-neutral-8 {
      fill: #2f2f30;
    }

    .sr-bb .srt-stroke-neutral-8 {
      stroke: #2f2f30;
    }

    .sr-bb .srt-fill-neutral-9 {
      fill: #1f1f21;
    }

    .sr-bb .srt-stroke-neutral-9 {
      stroke: #1f1f21;
    }

    .sr-bb .srt-fill-neutral-10 {
      fill: #2c2d2e;
    }

    .sr-bb .srt-stroke-neutral-10 {
      stroke: #2c2d2e;
    }

    .sr-bb .srt-fill-neutral-11 {
      fill: #6a6c6d;
    }

    .sr-bb .srt-stroke-neutral-11 {
      stroke: #6a6c6d;
    }

    .sr-bb .srt-fill-neutral-12 {
      fill: #acafb1;
    }

    .sr-bb .srt-stroke-neutral-12 {
      stroke: #acafb1;
    }

    .sr-bb .srt-fill-neutral-13 {
      fill: #28282a;
    }

    .sr-bb .srt-stroke-neutral-13 {
      stroke: #28282a;
    }

    .sr-bb .srt-fill-win {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-win {
      stroke: #36383e;
    }

    .sr-bb .srt-fill-draw {
      fill: rgba(238, 242, 245, 0.4);
    }

    .sr-bb .srt-stroke-draw {
      stroke: rgba(238, 242, 245, 0.4);
    }

    .sr-bb .srt-fill-lose {
      fill: #36383e;
    }

    .sr-bb .srt-stroke-lose {
      stroke: #36383e;
    }

    .sr-bb .srt-stop-base-1 {
      stop-color: transparent;
    }

    .sr-bb .srt-stop-primary-1 {
      stop-color: #ff0003;
    }

    .sr-bb .srt-stop-primary-2 {
      stop-color: #fa494c;
    }

    .sr-bb .srt-stop-primary-3 {
      stop-color: #ff1a1c;
    }

    .sr-bb .srt-stop-primary-4 {
      stop-color: #a00709;
    }

    .sr-bb .srt-stop-primary-5 {
      stop-color: #a00709;
    }

    .sr-bb .srt-stop-primary-6 {
      stop-color: #f86669;
    }

    .sr-bb .srt-stop-primary-7 {
      stop-color: #ff0003;
    }

    .sr-bb .srt-stop-primary-8 {
      stop-color: #ff0003;
    }

    .sr-bb .srt-stop-primary-9 {
      stop-color: #590d0e;
    }

    .sr-bb .srt-stop-primary-10 {
      stop-color: #d00406;
    }

    .sr-bb .srt-stop-primary-11 {
      stop-color: #ff1a1c;
    }

    .sr-bb .srt-stop-primary-12 {
      stop-color: #ff0003;
    }

    .sr-bb .srt-stop-home-1 {
      stop-color: #36383e;
    }

    .sr-bb .srt-stop-away-1 {
      stop-color: #36383e;
    }

    .sr-bb .srt-fill-neutral-14 {
      fill: #121213;
    }

    .sr-bb .srt-stroke-neutral-14 {
      stroke: #121213;
    }

    .sr-bb .srt-logo-powered-by-light {
      display: none;
    }

    .sr-bb .srt-logo-powered-by-dark {
      display: inline-block;
    }
  }
`;
